export enum MovementColor {
  'DEFAULT' = 'DEFAULT',
  'GREEN' = 'GREEN',
  'YELLOW' = 'YELLOW',
  'RED' = 'RED',
}
